export var BrowserName;
(function (BrowserName) {
    BrowserName["chrome"] = "Chrome";
    BrowserName["edge"] = "MS Edge";
    BrowserName["firefox"] = "Firefox";
    BrowserName["opera"] = "Opera";
    BrowserName["unknown"] = "Unknown";
})(BrowserName || (BrowserName = {}));
